import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import { Navigation } from "../components/Navigation";
import { Footer } from "../components/Footer";
import { CookieConsent, CookiePreferencesDialog } from "../components/CookieConsent";
import { MarketingAnalytics } from "../components/MarketingAnalytics";
import { JsonLd } from "../components/JsonLd";

const SITE_ORIGIN = "https://www.deskreplay.com";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "DeskReplay",
  alternateName: ["Desk Replay", "desk replay"],
  url: SITE_ORIGIN,
  logo: `${SITE_ORIGIN}/deskreplay.png`,
  description:
    "DeskReplay is enterprise screen recording software built for compliance, disputes, forensic audits, and workplace investigations. Capture what happened on managed desktops, search with AI, and export tamper-proof chain-of-custody evidence.",
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "sales",
    email: "sales@deskreplay.com",
    url: `${SITE_ORIGIN}/contact`,
  },
  sameAs: [
    "https://www.linkedin.com/company/deskreplay",
    "https://twitter.com/DeskReplay",
  ],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "DeskReplay",
  url: SITE_ORIGIN,
  description: "Screen Recording Built for Compliance",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${SITE_ORIGIN}/faq?q={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

export function Root() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname, hash]);

  return (
    <div className="theme-light min-h-screen bg-slate-950 text-slate-100" style={{ fontFamily: "'Inter', sans-serif" }}>
      <JsonLd schema={organizationSchema} id="organization" />
      <JsonLd schema={websiteSchema} id="website" />
      <Navigation />
      <main>
        <Outlet />
      </main>
      <Footer />
      <MarketingAnalytics />
      <CookieConsent />
      <CookiePreferencesDialog />
    </div>
  );
}
